var render = function render(){var _vm=this,_c=_vm._self._c;return _c('base-create',_vm._g(_vm._b({attrs:{"name":"settings-workspace-platform-create","title":"Plattform hinzufügen","width":400}},'base-create',_vm.$attrs,false),_vm.$listeners),[_c('SettingsWorkspacePlatformForm',{attrs:{"type":"create","platform":_vm.platform}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }